import styled from "@emotion/styled";
export const Label = styled("label")`
    display: flex;
    align-items: flex-start;
`;
//# sourceMappingURL=Label.js.map